import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AcceptedFileType,
  ConversationBadgePipe,
  ConversationRoutePipe,
  ConversationUnseenPipe,
  ConversationYourExpertPipe,
  MaxFileSize,
  UnreadConversationsCountPipe,
} from './conversation.pipe';
import { FirebaseTimestampsToDatePipe } from './firebase-timestamp-to-date';
import { InArrayPipe } from './in-array.pipe';
import {
  ChatSourceIconName,
  ChatProfileIconPipe,
  GetMessageMediaUrlPipe,
  IsFromYouPipe,
  IsSystemMessagePipe,
  MessageCodeBacktickPipe,
  MessageFrom,
  MessageStatusType,
  MessageVia,
} from './message.pipes';
import { TrimDescriptionPipe } from './ticket-pane.pipe';
import { MessageTime, TimestampsPipe } from './timestamp.pipe';
import { ViewIconPipe, ViewNamePipe } from './views.pipe';

const PIPES = [
  TimestampsPipe,
  MessageStatusType,
  ConversationRoutePipe,
  ConversationBadgePipe,
  ConversationUnseenPipe,
  ConversationYourExpertPipe,
  IsSystemMessagePipe,
  MessageFrom,
  MessageVia,
  ChatSourceIconName,
  MessageCodeBacktickPipe,
  TrimDescriptionPipe,
  FirebaseTimestampsToDatePipe,
  InArrayPipe,
  MessageTime,
  ViewIconPipe,
  ViewNamePipe,
  UnreadConversationsCountPipe,
  MaxFileSize,
  AcceptedFileType,
  GetMessageMediaUrlPipe,
  IsFromYouPipe,
  ChatProfileIconPipe,
];

@NgModule({
  imports: [CommonModule],
  declarations: [PIPES],
  exports: [PIPES],
})
export class ConversationPipesModule {}
